import {formatLegendItem} from "./formatters";

const LABEL_FONT = 'Euclid Circular A, sans-serif';


export const styleScroller = (chart, scrollerDataMapping)=>{
  const scroller = chart.scroller();
  scroller.fill("#ffffff");
  scroller.selectedFill("#EFF3FF 0.5");
  scroller.thumbs().fill('#000000');
  scroller.xAxis().enabled(false);
  scroller.column(scrollerDataMapping);
}

export const stylePlot = (plot, config) => {
  plot.background().stroke("#FFFFFF"); // Set plot border color
  const dataArea = plot.dataArea();
  dataArea.background().enabled(true);
  dataArea.background().fill('#fff').corners(0);
  // plot.yGrid().enabled(config?.yGrid ?? true).stroke('2 rgba(0, 0, 0, 0.1)');
  let ygrid = 'yGrid';
  if (config?.hasOwnProperty('yMinorGrid') && config.yMinorGrid===true){
    ygrid = 'yMinorGrid';
  }
  plot[ygrid]().enabled(config?.yGrid??true).stroke({
    dash: '4 2', color: "#ddd"
  });
  plot.xGrid().enabled(config?.xGrid??false).stroke('1 #F2F2F2');
  plot.yAxis(0).stroke('transparent'); // Left Y-axis
  plot.yAxis(0).ticks().stroke({ solid: '2 ', color: 'transparent' });
  plot.yAxis(0).ticks().length(5);
  plot.yAxis(0).labels().format(`{%Value}${config?.yLabelPostfix??''}`).fontColor("#000000").fontFamily(LABEL_FONT).fontSize(11); // Format labels with %

  // Enable and style the right Y-axis
  plot.yAxis(1).enabled(true).orientation("right");
  plot.yAxis(1).stroke('transparent'); // Right Y-axis
  plot.yAxis(1).ticks().stroke({ solid: '2', color: 'transparent' });
  plot.yAxis(1).ticks().length(5);
  plot.yAxis(1).labels().format(`{%Value}${config?.yLabelPostfix??''}`).fontColor("#000000").fontFamily(LABEL_FONT).fontSize(11); // Format labels with %

  plot.xAxis().minorLabels().enabled(false);
  plot.xAxis().labels().fontColor("#000000").fontFamily(LABEL_FONT).fontSize(11);
};


export const styleLegend = (chart, config) => {
  // Assuming `config` includes properties like `color`.
  chart.legend().useHtml(true);
  chart.legend().itemsFormat(function() {
    // `this` context refers to the legend item. Access the series name and value.
    try {
      return formatLegendItem(this?.seriesName, this?.value, this?.valuePercentChange, config);
    }
    catch (e) {
      return `${this?.seriesName}`
    }
  });
  chart.legend().titleFormat(function(){
    return ''
  })
};



export const finishDrawingChart = (chart, xTicks, ref, title, xPadding=50, yPadding=10)=>{
  chart.tooltip().useHtml(true);
  chart.title(title);
  chart.margin([0, 0, 0, 0]);
  chart.padding([yPadding, xPadding, yPadding, xPadding]);
  chart.xScale().ticksCount(xTicks);
  chart.container(ref);
  chart.draw();
}